export default __webpack_public_path__ + "static/media/ticket46.ed64a197.jpg";